(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["trust-signals-card"] && !Shopify.designMode) return;
  try {
    (function () {
    var details = document.querySelector('.delivery-promise__info-details');
    if (!details || window.innerWidth >= 750) return;

    /* Backdrop — sits just below the bottom sheet, above everything else */
    var backdrop = document.createElement('div');
    backdrop.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,0.45);z-index:2147483645;';
    document.body.appendChild(backdrop);

    /* Find Intercom launcher iframe/button to hide it while sheet is open */
    function setIntercom(visible) {
      var els = document.querySelectorAll(
        '#intercom-container, .intercom-launcher, [class*="intercom-"], iframe[name*="intercom"]'
      );
      for (var i = 0; i < els.length; i++) {
        els[i].style.visibility = visible ? '' : 'hidden';
      }
    }

    function open() {
      backdrop.style.display = 'block';
      document.body.style.overflow = 'hidden';
      setIntercom(false);
    }

    function close() {
      backdrop.style.display = 'none';
      document.body.style.overflow = '';
      setIntercom(true);
    }

    details.addEventListener('toggle', function () {
      if (window.innerWidth >= 750) return;
      details.open ? open() : close();
    });

    backdrop.addEventListener('click', function () {
      details.open = false;
      close();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
